import {useEffect, useRef} from "react";
import {useReactToPrint} from "react-to-print";

const PrintTicketHtml = ({html, htmlMulti, onAfterPrint}: {
    html?: string,
    onAfterPrint: () => void,
    htmlMulti?: string[]
}) => {
    const ticketRef = useRef<HTMLDivElement>(document.createElement('div'));

    const handlePrint = useReactToPrint({
        content: () => ticketRef.current,
        pageStyle: `
            @page {
                size: 144.5mm 70mm;
                margin: 0;
                padding: 0;
            }
            @media print {
                body, html {
                    margin: 0 !important;
                    padding: 0 !important;
                    height: auto !important;
                    overflow: visible !important;
                }
                .ticket-page {
                    width: 144.5mm;
                    height: 70mm;
                    page-break-after: always;
                    position: relative;
                    overflow: hidden;
                }
                .ticket-page:last-child {
                    page-break-after: auto;
                }
                .ticket-iframe {
                    width: 100% !important;
                    height: 100% !important;
                    border: none !important;
                    transform-origin: 0 0;
                }
                .ticket-wrapper-for-print {
                     display: block !important;
                     height: auto !important;
                }
                
            }
        `,
        onAfterPrint,
        removeAfterPrint: true
    });

    useEffect(() => {
        if (html || (htmlMulti?.length)) {
            handlePrint();
        }
    }, [handlePrint, html, htmlMulti]);

    if (!html && !htmlMulti?.length) return null;

    const tickets = html ? [html] : htmlMulti || [];

    return (
        <div style={{display: 'none'}}>
            <div ref={ticketRef} className={'ticket-wrapper-for-print'}>
                {tickets.map((ticketHtml, index) => (
                    <div
                        key={index}
                        className="ticket-page"
                        dangerouslySetInnerHTML={{ __html: ticketHtml }}
                    />
                ))}
            </div>
        </div>
    );
};

export default PrintTicketHtml;